import { styled } from 'styled-components'

export const Root = styled.div`
  position: absolute;
  top: -12px;
  right: 50px;
  padding: 5px 10px;
  border-radius: 38px;
  background-color: #1AACFF;
  color: #ffffff;
  font-size: 10px;
  font-weight: 400;
  overflow: hidden;
`

export const Blind = styled.div`
  position: absolute;
  inset: 0 0 50%;
  background-color: #ffffffcc;
`
